import React from "react"
import { Button } from "react-bootstrap"
import _ from "lodash"

import { fieldLabel } from "@/onboarding/features/product/models/fieldLabels"

import PermissionToggle from "@/onboarding/features/bidding/components/PermissionToggle"
import { EDITABLE_OPTIONS, REQUIRED_OPTIONS } from "@/onboarding/features/bidding/flagOptions"
import { CatalogueField, FieldSetting } from "@/onboarding/features/bidding/types"

const LOCKED_REASON = "Unlock this field to set Required or Optional"

type Props = {
  row: FieldSetting
  field: CatalogueField
  canSetRequired: boolean
  writeableStatus: React.ReactNode
  requiredStatus: React.ReactNode
  onWriteableChange: (writeable: boolean | undefined) => void
  onRequiredChange: (required: boolean | undefined) => void
  onRemove: () => void
}

const FieldPermissionRow = ({
  row,
  field,
  canSetRequired,
  writeableStatus,
  requiredStatus,
  onWriteableChange,
  onRequiredChange,
  onRemove,
}: Props): JSX.Element => {
  const subject = fieldLabel(row.name)

  return (
    <tr>
      <td>
        {subject}
        <div className="small text-muted">{_.startCase(field.section)}</div>
      </td>
      <td>
        <PermissionToggle
          subject={subject}
          options={EDITABLE_OPTIONS}
          selected={row.writeable}
          disabledReason={undefined}
          onChange={onWriteableChange}
        />
        {writeableStatus}
      </td>
      <td>
        {field.requiredConfigurable ? (
          <PermissionToggle
            subject={subject}
            options={REQUIRED_OPTIONS}
            selected={row.required}
            disabledReason={canSetRequired ? undefined : LOCKED_REASON}
            onChange={onRequiredChange}
          />
        ) : (
          <span className="small text-muted">Not applicable</span>
        )}
        {field.requiredConfigurable && requiredStatus}
      </td>
      <td>
        <Button variant="link" aria-label={`Remove ${subject}`} onClick={onRemove}>
          &times;
        </Button>
      </td>
    </tr>
  )
}

export default FieldPermissionRow
